import { CarrouselDto } from "./carrousel-dto";

export class Carrousel {
    src: string;
    urlBanner: string;

    static fromJson(json: CarrouselDto): Carrousel {
        var carrousel = new Carrousel();
        carrousel.src = json.src;
        carrousel.urlBanner = json.url_banner;
        return carrousel;
    }
}